import { useState, useEffect } from "react";
import { formatEditData } from "../utils/helpers";

const initialFormData = {
  ai_models: "",
  long_description: "",
  price: "",
  linked_print_provider: "",
  linked_product: "",
  short_description: "",
  title: "",
  canva: "",
  compressed_canva: "",
  json_file: null,
  compressed_json_file: null,
  template_preview: null,
  template_full: null,
  template_thumb: null,
  template_version: null,
  subcategory: "",
  subsubcategory: "",
  file: "",
  compressed_file: "",
  is_free: false,
  category: "",
  fileimagepreview: "",
  Design: "",
  thumbnails: [],
  tags: [],
  canvasWidth: null,
  canvasHeight: null,
  is_published: true,
  use_main_file_as_thumbnail: true,
};

export const useStepperForm = (editlistdata) => {
  const [stepperFormdata, setStepperFormdata] = useState(initialFormData);
  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    if (editlistdata) {
      const formattedData = formatEditData(editlistdata);
      setStepperFormdata(formattedData);
    }
  }, [editlistdata]);

  const handleChange = (key, value) => {
    setStepperFormdata((pre) => ({ ...pre, [key]: value }));
  };

  return {
    stepperFormdata,
    setStepperFormdata,
    handleChange,
    fieldErrors,
    setFieldErrors,
  };
};

